import {Tooltip} from '@mui/material'
import moment from 'moment'
import {Trans} from 'react-i18next'

interface KilnShellTooltipProps {
  refractoryName: string
  feedingDate?: string
  fromMeter: number
  toMeter: number
  children: React.ReactElement
}

export const KilnShellTooltip: React.FC<KilnShellTooltipProps> = ({
  refractoryName,
  feedingDate,
  fromMeter,
  toMeter,
  children
}) => {
  return (
    <Tooltip
      title={
        <div className={'flex flex-col'}>
          <div>
            <Trans
              i18nKey="refraPlanning.materialInstallations.tooltip.feedingDate"
              values={{
                feedingDate: feedingDate !== '' ? moment(feedingDate).format('MM/YYYY') : ''
              }}
            />
          </div>
          <div>
            <Trans
              i18nKey="refraPlanning.materialInstallations.tooltip.material"
              values={{
                material: refractoryName
              }}
            />
          </div>
          <div>
            <Trans
              i18nKey="refraPlanning.materialInstallations.tooltip.fromToInfo"
              values={{
                fromMeter: fromMeter,
                toMeter: toMeter
              }}
            />
          </div>
        </div>
      }
    >
      {children}
    </Tooltip>
  )
}
